import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { ListResponse, ObjectResponse } from '../interfaces';
import { AdjustmentEffectivenessPayload, AdjustmentEffectiveness, AdjustmentSummary } from '../models';
import { AppConfig } from './app-config';

@Injectable()
export class AdjustmentEffectivenessService extends BaseService<AdjustmentEffectivenessPayload> {

  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  // TODO: override, remove after all responses are updated
  public list(queryString?: string): Observable<ListResponse<AdjustmentEffectiveness>> {
    const apiUrl = this.applyQueryString(queryString);

    return this.http.get<ListResponse<AdjustmentEffectiveness>>(apiUrl);
  }

  // TODO: override, remove after all responses are updated
  public edit(id: number, model: AdjustmentEffectivenessPayload): Observable<ObjectResponse<AdjustmentSummary>> {
    return this.http.patch<ObjectResponse<AdjustmentSummary>>(`${this.getResourceUrl()}${id}`, model);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}adjustment-effectiveness/`;
  }
}
